<div class="w-100">
  <finx-date-picker
    [view]="'date'"
    [inline]="true"
    [selectionMode]="selectionMode"
    (datePickerChange)="dateChange($event)"
    [ngModelValue]="selectedDateRange"
    [inputStyle]="contentStyle"
    [class]="'range-calendar'"
    [textColor]="textColor"
  ></finx-date-picker>

  <div class="mx-0 p-0 mt-4 submit-button pointer-events-none" *ngIf="resetButtonContent">
    <finx-button
      type="button"
      (click)="onResetChange()"
      [labeltext]="renderedContent"
      class="nested-button pointer-events-none d-flex"
      [buttonStyle]="!isAllowedGlobalStyling ? resetButtonStyle : {}"
      [class]="isAllowedGlobalStyling ? globalStylingClass : 'w-100'"
      [style.height]="'100%'"
      [class.mandatory-cta-button]="!isAllowedGlobalStyling"
      [isAllowedGlobalStyling]="isAllowedGlobalStyling"
    ></finx-button>
  </div>
</div>
